const genderInputOptions = [
  { value: 'Male', label: 'זכר' },
  { value: 'Female', label: 'נקבה' },
  { value: 'Other', label: 'אחר' },
]

export { genderInputOptions }
